<!--
* @program: tyh-oa 
* @author: ly
* @description: typeString 
* @create: 2021-03-23 10:01
-->
<template>
    <div >
        <a-textarea
                @input="columnTrigger"
                auto-size
                v-if="editable"
                v-model:value="record[column.dataIndex]"
        />
        <div v-else style="width: 100%" @click="onClick">
            <OverSizeCol :text="cellValue"/>
        </div>
    </div>
</template>

<script>
    import typeBase from "./typeBase";


    export default {
        name: "typeString",
        mixins:[typeBase],
        methods:{
            onClick(){
              if(this.column.clickHandler){
                this.column.clickHandler(this.record,this.column)
              }
            }
        }
    }
</script>

<style scoped>

</style>